import { Component, OnInit, ElementRef, ViewChild, Renderer } from '@angular/core';
import { FormTemplate } from './formtemplate';
import { Router, NavigationStart } from '@angular/router';
import { FormtemplateService } from './formtemplate.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { FbeditorComponent } from './../../Shared/fbeditor/fbeditor.component';
import { CommondialogComponent } from '../../../app/Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import * as $ from 'jquery'; declare let $: any;
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-formtemplate',
  templateUrl: './formtemplate.component.html',
  styleUrls: ['./formtemplate.component.css']
})
export class FormtemplateComponent implements OnInit {
  @ViewChild('btnSaveFormTemplate', { static: true }) btnSaveFormTemplate: ElementRef;
  formTemplates: FormTemplate[] = []; itemsPerPage: number = 10; p: number = 1;
  sendMenuId: number; formElement: any; formTemplateId: any; btnName: string = 'Add Form Template'; _cleanedFormElement: any;
  sendPageName: string = 'Form Templates'; _fieldAliasList: any;
  public searchText: string;
  FormTemplatesTmp: any = [];
  FormTemplatesTmpactive: any = [];
  htmlData: any; _action: string; userid: number; confmsg: string; msg: string; currentForm: string; fbEditorTouched: boolean; isLoading: boolean; _menuId: any
  submitted = false;
  _actionRights: any; submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;
  showall: boolean = true;
  showallstatus: boolean = false;

  constructor(private formTemplateService: FormtemplateService, private toastr: ToastrService,
    private sanitizer: DomSanitizer, private _fbEditor: FbeditorComponent,
    private _frmBuilder: FormBuilder, private router: Router,
    private dialogService: DialogService, private localService: LocalService) {
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Form Templates_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Form Templates_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Form Templates_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Form Templates_action');
    }
  }
  //formgroup
  frmTemplateForm: FormGroup;
  frmTemplates: FormTemplate[];
  frmTemplate: FormTemplate;

  ngOnInit() {
    this.checkIsMenuMapped();
    this.frmTemplateForm = this._frmBuilder.group({
      formname: ['', [Validators.required]],
      description: ['', [Validators.required]]
    });
    this.formElement = '';
    this._action = 'add';
    this.formTemplateId = 0;
    this.getAllFormTemplates();
    this.currentForm = ''; this._cleanedFormElement = '';
    this.fbEditorTouched = false;
    this.LoadFieldList();
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
    this.searchText = '';
    this.FormTemplatesTmp = [];
    //this._fbEditor.removeToolBar();
    // $(document.getElementById("fb-editor")).formBuilder({ formData });
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedformtemplate");
    let data = arrays.find(ob => ob['name'] === 'Form Templates');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedformtemplate","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){     
      this.localService.setJsonValue("notauthorizedformtemplate",null);
      this.router.navigate(["home"]);      
    }
  }

  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  key: string = 'formname'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }


  getAllFormTemplates() {
    this.FormTemplatesTmp = [];
    this.FormTemplatesTmpactive = [];
    this.formTemplateService.getFormTemplates().subscribe(res => {
      this.FormTemplatesTmp = [];
      this.formTemplates = res;
      if (this.formTemplates.length != 0) {
        this.formTemplates.forEach(i => {
          if (i.formtemplateid != undefined) {
            this.FormTemplatesTmp.push(
              {
                formtemplateid: i.formtemplateid,
                formname: i.formname,
                active: i.active
              }
            );
          }

        })

        if (this.showallstatus == true) {
          this.FormTemplatesTmp.forEach(data => {
            if (data.active == 1) {
              this.FormTemplatesTmpactive.push(data);
            }
          });
          this.FormTemplatesTmp = [];
          this.FormTemplatesTmp = this.FormTemplatesTmpactive;
        }

      }
    }, error => {
      this.toastr.error('FormTemplate Data not Getting');
    })
  }
  getactiveinactive(showallp) {
    this.FormTemplatesTmpactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.FormTemplatesTmp.forEach(data => {
        if (data.active == 1) {
          this.FormTemplatesTmpactive.push(data);
        }
      });
      this.FormTemplatesTmp = [];
      this.FormTemplatesTmp = this.FormTemplatesTmpactive;
    }
    else {
      this.showall = true;
      this.FormTemplatesTmp = [];
      this.getAllFormTemplates();
    }
  }

  get formdata() { return this.frmTemplateForm.controls; }
  PostfrmTemplate(frmTemplate: FormTemplate) {
    this.submitted = true;
    if (this.frmTemplateForm.valid) {
      //this.userid = +localStorage.getItem('userid');
      this.userid = +this.localService.getJsonValue('userid');
      if ((this.formElement == undefined) || (JSON.parse(this.formElement).length == 0)) {
        this.toastr.error('Form template cannot be empty');
        return;
      }
      let res: any;
        res = this.dataValidation(this.formElement);
      if (res != '') {
        this.toastr.error('Master data should get selected for ' + res);
        return;
      }
      if ((this.formElement != undefined) || (JSON.parse(this.formElement).length != 0)) {
        this._cleanedFormElement = this.controlNameChange(this.formElement);       
        if (this._action == 'add') {
          frmTemplate.createdby = this.userid;
          frmTemplate.active = 1;
          frmTemplate.formtemplateid = 0;
          frmTemplate.htmldata = this._cleanedFormElement;
          this.formTemplateService.Post(frmTemplate).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success('Data added successfully');
                this.getAllFormTemplates();
                this.clearForm();
              }
              else { this.toastr.error('Form template exists already'); }
            }, error => {
              this.toastr.error(error);
              //console.log(error);
            });
        }

        if (this._action == 'update') {
          frmTemplate.modifiedby = this.userid;
          frmTemplate.active = 1;
          frmTemplate.formtemplateid = this.formTemplateId;
          frmTemplate.htmldata = this._cleanedFormElement;
          this.formTemplateService.Put(frmTemplate).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success('Data updated successfully');
                this.getAllFormTemplates();
                this.clearForm();
              }
              else { this.toastr.error('Form template exists already'); }
            }, error => {
              this.toastr.error(error);
              //console.log(error);
            });
        }
      }
      else {
        this.toastr.error('Form template cannot be empty');
      }
    }

  }

  LoadFieldList() {
    this.formTemplateService.getFieldAlias().subscribe((res) => {
      if (res != undefined) {
        this._fieldAliasList = res;
      }
    });
  }

  controlNameChange(data) {
    var arr1 = [];
    if ((data != undefined) && (data != null)) {
      var arr = JSON.parse(data);
      //get list of field alias name   
      if (arr.length > 0) {
        arr.forEach((item, index) => {
          if (item.name != undefined) {
            var alias = this._fieldAliasList.filter(e => e.fieldlabel == item.type);
            var ind = index + 1;
            if (alias.length != 0) {
              //if label is undefined
              if (item.label == undefined) {
                if (item.type == 'checkbox-group')
                  item.label = item.values[0].label;
              }
              var name = alias[0].fieldalias + (item.label === undefined ? '' : item.label) + ind;
              item.name = name;
            }
            else {
              item.name = item.label + ind;
            }
            var b = '';
            var replaceTxt = item.name.replace('&nbsp;', " ")
            var removeSpace = replaceTxt.split(/(\s+)/);
            if (removeSpace.length != 0) {
              removeSpace.forEach(a => {
                b = b + a.trim();
              });
              item.name = b.trim();
            }
          }
          else {
            var alias = this._fieldAliasList.filter(e => e.fieldlabel == item.type);
            var ind = index + 1;
            if (alias.length != 0) {
              var name = alias[0].fieldalias + (item.label === undefined ? '' : item.label) + ind;
              item.name = name;
            }
            else {
              item.name = item.label + ind;
            }
            var b = '';
            var replaceTxt = item.name.replace('&nbsp;', " ")
            var removeSpace = replaceTxt.split(/(\s+)/);
            if (removeSpace.length != 0) {
              removeSpace.forEach(a => {
                b = b + a.trim();
              });
              item.name = b.trim();
            }
          }
          if (item.name != undefined) {
            var txt = this.removeSpecialCharacters(item.name);
            arr[index]["formcontrolname"] = txt;
          }
          if (((item.type == "select") && (item.description == 'Masters')) || ((item.type == "radio-group") && (item.description == 'Masters')) || ((item.type == "checkbox-group") && (item.description == 'Masters') && (item.values.length > 1))) {
            var valueList = item.values;
            if ((valueList != undefined) && (valueList.length != 0)) {
              var s = valueList.filter(e => e.selected == true);
              if (s != undefined || s.length != 0) {
                arr[index]["tablename"] = s[0].label;
              }
            }
          }
        });
        return JSON.stringify(arr);
      }
    }

  }

  removeSpecialCharacters(text) {
    var cleanedTxt = text.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
    return cleanedTxt;
  }

  dataValidation(data) {
   var label = '';
    var controlList = JSON.parse(data);
    if ((controlList != undefined) && (controlList.length != 0)) {      
      controlList.forEach(item => {
        if (((item.type == "select") && (item.description == 'Masters')) || ((item.type == "radio-group") && (item.description == 'Masters')) || ((item.type == "checkbox-group") && (item.description == 'Masters') && (item.values.length>1))) {
          var valueList = item.values;        
          if ((valueList != undefined) && (valueList.length != 0)) {
            var s = valueList.filter(e => e.selected == true);
            if (s == undefined || s.length == 0) {
             // this.toastr.error('Master data should get selected for ' + item.label);
              label = item.label;
              return label;
            }
          }
        }
      });
    }
   
    return label;  
  }


  getfrmValue($event) {
    this.formElement = $event;
  }

  editorTouched() {
    this.fbEditorTouched = true;
    //console.log(this._fbEditor.formElementJson);
    // this._fbEditor.get();
  }

  clearForm() {
    this._action = 'add';
    this.btnName = 'Add Form Template';
    this.currentForm = '';
    this.submitted = false;
    this.fbEditorTouched = false;
    this._fbEditor.clearBuilder();
    //this.FormTemplatesTmp = [];
    this.formElement = ''; this._cleanedFormElement = '';
    this.frmTemplateForm.reset();
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
  }

  editFormTemplate(formTemplateId, formname, action) {
    this.submitShow = true;
    if ((this.currentForm != '') && ((this.frmTemplateForm.touched == true) || (this.fbEditorTouched == true))) {
      this.confirmation(formTemplateId, formname, action);
    }
    else {
      this._action = 'update';
      this.btnName = 'Update';
      this.currentForm = formname;
      this.formTemplateId = formTemplateId;
      if (this.formTemplates.length != 0) {
        var s = this.formTemplates.filter(e => e.formtemplateid == formTemplateId);
        if ((s != undefined) && (s.length != 0)) {
          this.htmlData = s[0].htmldata;
          this.frmTemplateForm.controls['formname'].setValue(s[0].formname);
          this.frmTemplateForm.controls['description'].setValue(s[0].description);
          // this.htmlData = this.sanitizer.bypassSecurityTrustHtml(s[0].htmldata);    
          this._fbEditor.setValue(this.htmlData);
        }
        else
          this.htmlData = '';
      }
    }

  }

  statusChange(id, option) {
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    if (option == 'activate') {
      this.confmsg = "activate";
      this.frmTemplateForm.value.active = 1;
      this.msg = "Record activated successfully";
    }
    else {
      this.confmsg = "deactivate";
      this.frmTemplateForm.value.active = 0;
      this.msg = "Record deactivated successfully";
    }
    this.frmTemplateForm.value.formtemplateid = id;
    this.frmTemplateForm.value.modifiedby = this.userid;
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true

      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.formTemplateService.Delete(this.frmTemplateForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success(this.msg);
                this.getAllFormTemplates();
              }
              else {
                this.toastr.warning('Form template is mapped to form config, not able to deactivate');
              }
            }, error => {
              //console.log(error);
              this.toastr.error(error);
            });
        }
      });
  }

  confirmation(formtemplateid, formname, action) {
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Confirmation',
        message: 'Would you like to save changes? ' + this.currentForm,
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          //this.PostfrmTemplate(this.frmTemplateForm.value);
          $(document.getElementById("btnSave")).click();
        }
        else {
          this.currentForm = '';
          this.frmTemplateForm.markAsUntouched();
          this.fbEditorTouched = false;
          this.editFormTemplate(formtemplateid, formname, action);
        }
      });

  }
}
